import { CSSObject } from "@emotion/react";

export const fieldsetCss: CSSObject = {
  border: 0,
  margin: "24px 0 0",
  padding: 0,
};

export const listCss: CSSObject = {
  padding: 0,
};
